export const requestPermission = (handle, options) => {
  return handle.requestPermission(options)
}
